<script>
import SectionContact from '@components/SectionContact'
export default {
  components: {
    SectionContact
  },
  data() {
    return {
      
    }
  }
}
</script>

<template>
  <div :class="$style.sectionContact" class="section isSmallPt pb-0">
    <SectionContact/>
  </div>
</template>

<style lang="scss" module>
  .sectionContact{
    position: relative;
    &:after {
      content:'';
      position: absolute;
      background-image: url('@assets/images/plan/paw-2.svg');
      background-repeat: no-repeat;
      background-size: cover;
      width: 165px;
      height: 196px;
      bottom: -50px;
      right: 0;
      @include max-lg {
        display: none;
      }
    }
    &:before {
      content:'';
      position: absolute;
      background-image: url('@assets/images/basicplan/paw-1.svg');
      background-repeat: no-repeat;
      background-size: cover;
      width: 11%;
      padding-bottom: 13%;
      bottom: 0%;
      left: -20px;
      @include max-lg {
        display: none;
      }
    }
    :global {
      .sectionContact {
       
      }
    }

    
  }
</style>